import { createApp } from "vue";
// import * as Vue from 'vue' // in Vue 3
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "@vueform/multiselect/themes/default.css"
import ArgonDashboard from "./argon-dashboard";
import Datepicker from '@vuepic/vue-datepicker';
import Multiselect from '@vueform/multiselect';
import Notifications from '@kyvg/vue3-notification'

axios.defaults.baseURL =  process.env.NODE_ENV === 'production' ?  'https://sanko-api.bhinneka.biz/mid-api/sanko/' : 'http://localhost:58024/mid-api/sanko/';

const appInstance = createApp(App);
appInstance.component('Datepicker', Datepicker);
appInstance.component('Multiselect', Multiselect);
appInstance.use(VueAxios, axios)
appInstance.use(Notifications);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(Multiselect);
appInstance.mount("#app");
